// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__CulEb","logo":"Footer_logo__vN7-C","links":"Footer_links__xJ8g+","tyger":"Footer_tyger__6fUmm"};